@use '@/styles/tokens' as *;

/* Figma 787:678824 — a white card floating over the satellite plate. Absolute inside `.mapArea`,
 * positioned by `placeMapPanel`, so it is in the same coordinate space that arithmetic answers in.
 *
 * z-index 3: above the legend and the control stack (2) and above the bottom-edge notice (1), since
 * the panel is the thing the Grower just asked for. Ticket 15's search results render above it in
 * turn (113586 §4g).
 *
 * The shadow is a deliberate addition — Figma draws none, and the sibling `.skipped` notice on this
 * same canvas already uses `--shadow-surface` for exactly the "white card over imagery" problem. */
.panel {
  position: absolute;
  z-index: 3;
  background: var(--surface-card);
  box-shadow: var(--shadow-surface);
  /* 113588 §16d — at 200% browser zoom the CSS viewport halves, and a panel wider than the map area
   * would push a horizontal scrollbar onto the page. */
  max-width: 100%;

  /* The mixin emits its own `&:focus-visible`, so it is included bare — nesting it inside another
   * one compiles to `:focus-visible:focus-visible`. Same usage as `.marker` in device-markers. */
  @include focus-ring;
}

/* 113586 §4a — the Field panel's card. */
.padded {
  padding: var(--space-3);
  border-radius: $radius-xl;
}

/* Figma 864:558014 — the quick view carries its own padding, so its header rule spans the card. */
.flush {
  border-radius: $radius-md;
}
